import COLORS from './colors'
import { FONT_SIZES, FONT_WEIGHTS, LINE_HEIGHTS } from './constants'

export default {
  colors: COLORS,
  fontSizes: FONT_SIZES,
  fontWeights: FONT_WEIGHTS,
  lineHeights: LINE_HEIGHTS,

  space: [0, 4, 8, 16, 20, 32, 64],
}
